import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper/Paper';
import { noop } from '../../../../utils/utils';
import styles from '../../../../shared/components/SearchBar/SearchBar.module.css';

class SearchBar extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
    onSearch: PropTypes.func,
  };

  static defaultProps = {
    placeholder: 'Search',
    searchTerm: '',
    onSearch: noop,
  };

  state = {
    searchTerm: '',
  };

  componentDidMount() {
    let previousSearch = sessionStorage.getItem('partner_search');
    if (previousSearch != null) {
      let json = JSON.parse(previousSearch);
      this.setState({
        searchTerm: json.searchTerm,
      });
    }
  }

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  searchOnPressEnter = (event) => {
    if (event.key === 'Enter') {
      const searchTerm = (this.state.searchTerm || '').trim();
      event.preventDefault();
      this.searchAndStoreParams(searchTerm);
    }
  };

  searchAndStoreParams(searchTerm) {
    sessionStorage.setItem(
      'partner_search',
      JSON.stringify({
        searchTerm: searchTerm,
      }),
    );
    this.props.onSearch(searchTerm);
  }

  render() {
    return (
      <>
        <Paper className={styles.searchBar}>
          <SearchIcon className={styles.searchIcon} color="action" />
          <Input
            id="searchInput"
            className={styles.searchInput}
            placeholder={this.props.placeholder}
            type="search"
            value={this.state.searchTerm}
            onChange={this.handleChange('searchTerm')}
            onKeyPress={this.searchOnPressEnter}
            disableUnderline
          />
        </Paper>
      </>
    );
  }
}

export default SearchBar;
